// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"235":"UIUX","443":"about","596":"404"}[chunkId] || chunkId) + "." + {"235":"c0373626","265":"58e27747","443":"b4b17e0c","596":"f74b2f0a"}[chunkId] + ".js";
};